import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const AuditPage = lazy(() => import('@/pages/audit'));

export const Route = createFileRoute('/audit')({
  component: function AuditRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <AuditPage />
      </Suspense>
    );
  },
});
